import React from "react";
import { LabeledText, Stack } from "sprint-common-web";

export const renderCodes = ({
    audioCodes,
    dynamicSubtitles,
    embeddedSubtitles
}: {
    audioCodes?: string[];
    dynamicSubtitles?: string[];
    embeddedSubtitles?: string[];
}): JSX.Element | null => {
    if (!audioCodes?.length && !dynamicSubtitles?.length && !embeddedSubtitles?.length) {
        return null;
    }

    return (
        <Stack data-testId="languages-listing-codes">
            {!!audioCodes?.length && (
                <LabeledText
                    textFontSize={12}
                    labelFontSize={12}
                    direction="horizontal"
                    label="Audio:"
                    value={audioCodes.join(", ")}
                />
            )}
            {!!embeddedSubtitles?.length && (
                <LabeledText
                    textFontSize={12}
                    labelFontSize={12}
                    direction="horizontal"
                    label="Embedded subtitle:"
                    value={embeddedSubtitles.join(", ")}
                />
            )}
            {!!dynamicSubtitles?.length && (
                <LabeledText
                    textFontSize={12}
                    labelFontSize={12}
                    direction="horizontal"
                    label="Dynamic subtitle:"
                    value={dynamicSubtitles.join(", ")}
                />
            )}
        </Stack>
    );
};
